import { mapState } from 'pinia';
import type { Component } from '~/types';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';

export default defineNuxtComponent({
  created() {
    if (this.currentPage && process.server) {
      this.updateMetaTags();
    }
  },

  mounted() {
    if (this.cssVariablesBinding) {
      const rootElement = document.querySelector(':root');
      if (rootElement && rootElement.style) {
        Object.keys(this.cssVariablesBinding).forEach((key) => {
          if (this.cssVariablesBinding[key]) {
            rootElement.style.setProperty(key, this.cssVariablesBinding[key]);
          }
        });
      }
    }
  },

  methods: {
    runScript(id: string, path: string) {
      const element = document.getElementById(id);
      if (element) {
        element.remove();
      }
      const script = document.createElement('script');
      script.src = path;
      script.id = id;
      script.type = 'text/javascript';
      document.body.appendChild(script);
    },

    updateMetaTags() {
      if (this.currentPage?.title) {
        const store = useCoreStore();
        store.updateMetaTagsGroup({
          title: this.currentPage.title,
          is_noindex: this.currentPage.is_noindex,
          seo_meta_description: this.currentPage.seo_meta_description,
          seo_meta_title: this.currentPage.seo_meta_title,
          is_nofollow: this.currentPage.is_nofollow,
          og_meta_title: this.currentPage.og_meta_title,
          og_meta_description: this.currentPage.og_meta_description,
          og_meta_twitter_card: this.currentPage.og_meta_twitter_card,
          og_meta_image: this.currentPage.og_meta_image,
        });
      }
    },
  },

  computed: {
    ...mapState(useWebsiteStore, ['themeDesign', 'company', 'currentPage', 'cssVariables', 'sidebarComponents']),

    activeContainer() {
      if (this.currentPage && this.currentPage.container_id && this.currentPage.container) {
        return this.currentPage.container;
      } else if (this.themeDesign && this.themeDesign.container_id && this.themeDesign.container) {
        return this.themeDesign.container;
      }
      return null;
    },
  },

  watch: {
    $route(a, b) {
      if (this.currentPage && a.name !== b.name) {
        this.updateMetaTags();
      }
    },
  },
});
